import { Checkbox } from '..';
import { DropdownFilterOptionType } from './DropdownFilter';

type DropdownFilterFlatOptionsProps = {
  options: DropdownFilterOptionType[];
  value: string[];
  onChange?: (value: string) => void;
};

const DropdownFilterFlatOptions = ({ options, value, onChange }: DropdownFilterFlatOptionsProps) => {
  return (
    <>
      {options.map((option) => (
        <div key={option.label} className="whitespace-nowrap">
          <Checkbox
            label={option.label}
            checked={value.includes(option.value)}
            onChange={() => onChange && onChange(option.value)}
            disabled={option.disabled}
          />
        </div>
      ))}
    </>
  );
};

export default DropdownFilterFlatOptions;
